module.exports = __webpack_public_path__ + "static/media/logo.c657d653.png";